import React, { useState } from "react";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import WavesIcon from "@mui/icons-material/Waves";
import { useTideData } from "../../hooks/useTideData";
import { TideTableCompact } from "./TideTableCompact";
import { TideTableExpanded } from "./TideTableExpanded";

const TideTable = ({ station }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  const {
    tideData: allTideEvents,
    stationName,
    loading,
    error,
    groupedEvents,
    nextTide,
  } = useTideData(station);

  // Toggle expand/collapse
  const toggleExpanded = () => setExpanded(!expanded);

  // Render loading state
  if (loading) {
    return (
      <Box sx={{ width: "100%", p: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <WavesIcon color="primary" />
          <Typography variant="subtitle1" color="primary">
            Tide Schedule
          </Typography>
          <Skeleton variant="text" width={100} />
        </Stack>
        <Skeleton variant="rectangular" height={120} animation="wave" />
      </Box>
    );
  }

  // Render error state
  if (error || allTideEvents.length === 0) {
    return (
      <Box
        sx={{
          width: "100%",
          p: 2,
          border: `1px dashed ${theme.palette.divider}`,
          borderRadius: 1,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <WavesIcon color="disabled" />
          <Typography variant="subtitle1" color="textSecondary">
            {error || "No tide data available"}
          </Typography>
        </Stack>
      </Box>
    );
  }

  // Render compact or expanded mode based on state
  return expanded ? (
    <TideTableExpanded
      stationName={stationName}
      groupedEvents={groupedEvents}
      nextTide={nextTide}
      toggleExpanded={toggleExpanded}
    />
  ) : (
    <TideTableCompact
      stationName={stationName}
      allTideEvents={allTideEvents}
      nextTide={nextTide}
      toggleExpanded={toggleExpanded}
    />
  );
};

export default TideTable;
